module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Barcode-28ec6f025b6a900da0d93b4ab42ee77e.svg";